import React from 'react';

interface VideoProps {
    source: string;
    className?:string;
    poster?: string;
}

export const Video = (props:VideoProps) => {
    const { className, source, poster } = props;

    const handleClick = (e)=>{
        if(e.target.pause)
            e.target.play();
        return true;
    };

    

    return (
        <video
            className={`${className ? className : ''}`}
            controls={true}
            poster={poster ? poster : ''}
            onClick={handleClick}
            preload="auto" >
          <source src={source} type="video/mp4" />
        </video>
    )
}
